import { render, staticRenderFns } from "./FivePercentRules.vue?vue&type=template&id=404a59b7"
import script from "./FivePercentRules.vue?vue&type=script&lang=ts"
export * from "./FivePercentRules.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports